<template>
    <div class="outer">
        <Header></Header>
        <div class="user">
            <div class="user_container">
                <div class="userLeft">
                    <ul>
                        <li v-for="(item, index) in lists" :key="index" :class="['item']">
                            <p>{{ item.name }}</p>
                        </li>
                    </ul>
                </div>
                <div class="userRight">
                    <div class="right_container">
                        <div class="login_format">
                            <p class="title">更新个人信息</p>
                            <el-form :model="ruleFormRegister" status-icon :rules="registerRules" ref="ruleFormRegister" label-width="100px" class="demo-ruleForm">
                                <el-form-item prop="avatar" label="头像：">
                                    <el-upload v-if="!ruleFormRegister.avatar"
                                        :headers="uploadHeaders"
                                        :action="getNoSecretAction()"
                                        :data="{type: 'avatar'}"
                                        :limit="1" :on-change="handleChangeAvatar"
                                        :on-success="handleSuccessAvatar" 
                                        :on-error="handleErrorFile" ref="upload"
                                        :on-exceed="handleExceedFile">
                                        <el-button v-if="!isUploadAvatar" >点击上传</el-button>
                                        <el-button v-else class="finishBtn">上传完成</el-button>
                                    </el-upload>
                                    <div v-else class="avatar">
                                        <img :src="ruleFormRegister.avatar" alt="">
                                        <el-button class="finishBtn" @click="resetAvatar">重新上传</el-button>
                                    </div>
                                </el-form-item>
                                <el-form-item prop="username" label="用户名：">    
                                    <el-input v-model="ruleFormRegister.username" autocomplete="off"></el-input>
                                </el-form-item>
                                <el-form-item prop="phone" label="手机号：">
                                    <div class="phone">
                                        <span>{{ ruleFormRegister.phone ? ruleFormRegister.phone : '暂未绑定' }}</span>
                                        <el-button v-if="!ruleFormRegister.phone" class="bind" @click="changeBindPhone">立即绑定</el-button>
                                        <el-button v-else class="bind" @click="changeBindPhone">更换绑定</el-button>
                                    </div>
                                </el-form-item>
                                <el-form-item prop="nickname" label="昵称：">
                                    <el-input v-model="ruleFormRegister.nickname" maxlength="20" autocomplete="off"></el-input>
                                </el-form-item>
                                <el-form-item prop="passwordRegister" label="密码：">
                                    <el-input type="password" v-model="ruleFormRegister.passwordRegister" autocomplete="off"></el-input>
                                </el-form-item>
                                <el-form-item prop="rePassword" label="确认密码：">
                                    <el-input type="password" v-model="ruleFormRegister.rePassword" autocomplete="off"></el-input>
                                </el-form-item>
                                <el-form-item prop="birthday" label="生日：">
                                    <el-date-picker
                                        v-model="ruleFormRegister.birthday"
                                        type="date"
                                        placeholder="选择日期">
                                    </el-date-picker>
                                </el-form-item>
                                <!-- <el-form-item prop="email" label="邮箱：">
                                    <el-input v-model="ruleFormRegister.email" autocomplete="off"></el-input>
                                </el-form-item> -->
                                <el-form-item prop="unit" label="单位：">
                                    <el-input v-model="ruleFormRegister.unit" autocomplete="off"></el-input>
                                </el-form-item>
                                <el-form-item prop="unitIntro" label="单位描述：">
                                    <el-input v-model="ruleFormRegister.unitIntro" autocomplete="off"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <div class="button">
                                        <el-button @click="userToRegister" class="login">提&nbsp;&nbsp;交</el-button>
                                    </div>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="dialog-container">
            <el-dialog
                title="绑定手机号"
                :visible.sync="dialogVisible"
                width="30%"
                @close="handleClose">
                <el-form :model="formPhone" ref="formPhone" :rules="rulesPhone" label-width="80px">
                    <el-form-item prop="phone" label="手机号：">
                        <el-input style="width: 80%;" v-model="formPhone.phone" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item prop="code" label="验证码：">
                        <el-input style="width: 80%;" v-model="formPhone.code" autocomplete="off">
                            <el-button slot="append" @click="getCode" class="login" :disabled="isSending || countdown > 0">
                                {{ isSending ? '发送中...' : countdown > 0 ? `${countdown}秒后重试` : "获取验证码" }}
                            </el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <div class="button">
                            <el-button @click="userToLogin" class="login">提&nbsp;&nbsp;交</el-button>
                        </div>
                    </el-form-item>
                </el-form>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import Header from "../../components/header/index.vue"
import { firstLogin, getUserInfo, getVerifyCode, checkRepeat, changeUserInfo, changeUserPhone } from '../../util/index'
import { md5 } from "js-md5"
import { baseUrl } from "../../util/constant"
import { mapState } from 'vuex'
import { formatTimestampToDate } from "../../util/tool"
export default {
    data() {
        var checkAccount = (rule, value, callback) => {
            if (value==='') {
                return callback(new Error('账号不能为空'));
            } else if (!/^[a-zA-Z0-9_-]+$/.test(value)) {
                return callback(new Error('账号只能包含字母、数字、下划线或横线'));
            } else if (!/^.{6,20}$/.test(value)) {
                return callback(new Error('账号长度必须在6到20个字符之间'));
            } else {
                callback(); // 验证通过
            }
        }
        // 密码
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } 
            setTimeout(() => {
                var myReg=/^(?=.*[a-z])(?=.*\d)[^]{8,16}$/;
                if (!myReg.test(value) ) {
                    callback(new Error('密码必须包含数字,字母,且不少于8位'));
                } else {
                    callback();
                }
            }, 1000);
        };
        // 再次输入密码
        var validateRePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.ruleFormRegister.passwordRegister) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        }
        // 手机号
        var checkNum = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('手机号不能为空'));
            }
            setTimeout(() => {
                // console.log(value);
                var myReg=/^[1][3,4,5,7,8][0-9]{9}$/;
                if (!myReg.test(value) ) {
                    callback(new Error('请输入正确的手机号码'));
                } else {
                    callback();
                }
            }, 0);
        };
        // 验证码
        var checkCode = async(rule, value, callback) => {
            if (value === '') {
                callback(new Error('验证码不能为空'));
            }
            console.log(value);
            const token = window.localStorage.getItem('userToken');
                            
            setTimeout(() => {
                // console.log(value);
                var myReg=/^[0-9]{6}$/;
                if (!myReg.test(value) ) {
                    callback(new Error('请输入正确的6位数验证码'));
                } else {
                    callback();
                }
            }, 1000);
        };
        var validateName = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入联系人姓名'));
            } else {
                callback();
            }
        }
        return {
            dialogVisible: false,
            isSending: false,
            isUploadAvatar: false,
            countdown: 0,
            isPhoneRepeated: false,
            focusArrayRegister:[false,false,false,false,false,false,false,false],
            lists:[
                {
                    path: '/user/user_info',
                    name: '信息填写',
                }
            ],
            ruleFormRegister: {  // 注册的表单
                // accountRegister:'',
                passwordRegister: '',
                rePassword: '',
                unit:'',
                // email:'',
                birthday:'',
                unitIntro:'',
                username:'',
                nickname: '',
                phone: '',
                avatar: '',
            },
            registerRules: {
                accountRegister: [
                    { validator: checkAccount, trigger: 'blur' }
                ],
                passwordRegister: [
                    { validator: validatePass, trigger: 'blur' }
                ],
                rePassword: [
                    { validator: validateRePass, trigger: 'blur' }
                ],
                username: [
                    {
                        validator: async (rule, value, callback) => {
                            if (value==='') {
                                return callback(new Error('用户名不能为空'));
                            } else if (!/^[a-zA-Z0-9_-]+$/.test(value)) {
                                return callback(new Error('用户名只能包含字母、数字、下划线或横线'));
                            } else if (!/^.{6,20}$/.test(value)) {
                                return callback(new Error('用户名长度必须在6到20个字符之间'));
                            }
                            // 获取 token
                            const token = window.localStorage.getItem('userToken');
                            
                            try {
                                // 检查用户名是否重复
                                const isRepeat = await checkRepeat('username', value, token);
                                if (!isRepeat.data) {
                                    callback(new Error("用户名已存在"));
                                } else {
                                    callback(); // 验证通过
                                }
                            } catch (error) {
                                callback(new Error("验证失败，请重试"));
                            }
                        }, 
                        trigger: 'blur' 
                    } 
                ],
                // phone: [
                //     { validator: checkNum, trigger: 'blur' }
                // ],
            },
            formPhone: {
                phone: '',
                code: '',
            },
            rulesPhone: {
                phone: [
                    { 
                        validator: async (rule, value, callback) => {
                            const token = window.localStorage.getItem('userToken');
                            if (value === '') {
                                callback(new Error('手机号不能为空'));
                            }
                            setTimeout(() => {
                                // console.log(value);
                                var myReg=/^[1][3,4,5,7,8][0-9]{9}$/;
                                if (!myReg.test(value) ) {
                                    callback(new Error('请输入正确的手机号码'));
                                } else {
                                    callback();
                                }
                            }, 0);
                            try {
                                // 检查手机号是否重复
                                const isRepeat = await checkRepeat('phone', value, token);
                                console.log(!isRepeat.data);
                                if (!isRepeat.data) {
                                    console.log('手机号被绑定了');
                                    // callback(new Error("手机号已绑定"));
                                    this.$message.error("手机号已绑定");
                                    this.isPhoneRepeated = true;
                                    return
                                } else {
                                    this.isPhoneRepeated = false;
                                    callback(); // 验证通过
                                }
                            } catch (error) {
                                callback(new Error("验证失败，请重试"));
                            }
                        }, 
                        required: true,
                        trigger: 'blur' 
                    }
                ],
                code: [
                    { validator: checkCode, trigger: 'blur', required: true }
                ],
            }
        };
    },
    computed:{
        ...mapState(['userInformation']),
        uploadHeaders() {
            return {
                Authorization: window.localStorage.getItem('userToken')
            }
        }
    },
    methods:{
        resetAvatar(){
            this.ruleFormRegister.avatar = '';
        },
        handleErrorFile(){
            
        },
        handleExceedFile(){
            this.$message.error('只能上传一个文件')
        },
        handleChangeAvatar(){

        },
        handleSuccessAvatar(res, file) {
            this.ruleFormRegister.avatar = res.data.fileUrl;
            this.isUploadAvatar = true;
        },
        getNoSecretAction() {
            return baseUrl + '/upload/image'
        },
        handleClose(done) {
            // 清除
            this.$refs['formPhone'].resetFields();
            this.$refs['formPhone'].clearValidate();
            this.dialogVisible = false;
        },
        startCountdown(){
            this.countdown = 60;
            const timer = setInterval(() => {
                this.countdown--;
                if (this.countdown <= 0) {
                    clearInterval(timer);
                }
            }, 1000);
        },
        async checkNum(rule, value, callback) {
            if (value === '') {
                callback(new Error('手机号不能为空'));
            } else {
                const myReg = /^[1][3,4,5,7,8][0-9]{9}$/;
                if (!myReg.test(value)) {
                    callback(new Error('请输入正确的手机号码'));
                } else {
                    callback();
                }
            }
            try {
                // 检查手机号是否重复
                const isRepeat = await checkRepeat('phone', value, token);
                console.log(!isRepeat.data);
                if (!isRepeat.data) {
                    console.log('手机号被绑定了');
                    // callback(new Error("手机号已绑定"));
                    this.$message.error("手机号已被其他号绑定");
                    this.isPhoneRepeated = true;
                    return
                } else {
                    this.isPhoneRepeated = false;
                    callback(); // 验证通过
                }
            } catch (error) {
                callback(new Error("验证失败，请重试"));
            }
        },
        getCode(){
            if(this.countdown > 0 || this.isSending) {
                return
            }
            let obj = {
                phone: this.formPhone.phone,
            }
            if(!obj.phone){
                this.$message.info('请输入手机号');
                this.isSending = false;
                return
            }
            let rule = ''
            this.checkNum(rule, obj.phone, (error) => {
                if(this.isPhoneRepeated){
                    this.isSending = false;
                    return
                }else{
                    getVerifyCode(obj).then((res) => {
                        if(res.code === 200){
                            this.isSending = true;
                            this.startCountdown();
                            this.$message({
                                message: '验证码已发送',
                                type: 'success'
                            });
                            this.isSending = false;
                        }
                    })
                }
            })
        },
        userToLogin(){
            let obj = {
                phone: this.formPhone.phone,
                code: this.formPhone.code,
            }
            this.$refs['formPhone'].validate(valid=>{
                if(valid){
                    let token = window.localStorage.getItem('userToken');
                    changeUserPhone(obj, token).then((res) => {
                        if(res.code === 200){
                            this.$message.success('绑定成功');
                            this.dialogVisible = false;
                            // 隐藏部分手机号
                            this.ruleFormRegister.phone = this.formPhone.phone.replace(/^(\d{4})\d{4}(\d{2})$/, '$1****$2');
                        }
                    })
                }else{
                    this.$message.error('请输入正确的手机号和验证码');
                    this.isSending = false;
                }
            })
        },
        changeBindPhone(){
            this.dialogVisible = true;
        },
        registerFocusHandle(number){
            this.$set(this.focusArrayRegister,number,true)
        },
        userToRegister(){
            // console.log(window.localStorage.getItem('openId'));
            let obj = {
                username: this.ruleFormRegister.username,
                password: md5(this.ruleFormRegister.passwordRegister),
                // phone: this.ruleFormRegister.phone,
                nickname: this.ruleFormRegister.nickname,
                // birthday: this.ruleFormRegister.birthday,
                // name: this.ruleFormRegister.name,
                // tags: this.ruleFormRegister.tags,
            }
            if(this.ruleFormRegister.birthday) obj.birthday = formatTimestampToDate(this.ruleFormRegister.birthday);
            if(this.ruleFormRegister.unit) obj.unit = this.ruleFormRegister.unit;
            if(this.ruleFormRegister.unitIntro) obj.unitIntro = this.ruleFormRegister.unitIntro;
            if(this.ruleFormRegister.avatar) obj.avatar = this.ruleFormRegister.avatar;
            // console.log(formData);
            // 表单验证
            this.$refs['ruleFormRegister'].validate((valid) => {
                if (valid) {
                    let token = window.localStorage.getItem('userToken');
                    changeUserInfo(obj, token).then((res) => {
                        if(res.code === 200){
                            this.$message.success('修改成功，已为您跳转首页');
                            // 修改成功，跳转首页
                            this.$router.push('/index');
                            // this.loginOrRegister = 'login';
                        }else{
                            this.$message.error(res.message)
                        }
                    })
                }else {
                    this.$message.error('请完善信息');
                    return false;
                }
            })
        },
        getUserInformation(){
            const userToken = window.localStorage.getItem("userToken")
            console.log(userToken);
            let obj = { token: userToken }
            getUserInfo(obj).then(res=>{
                if(res.code === 200){
                    // if(res.data.status !== 2) {
                    //     this.$message.success('非新用户修改信息，已跳转个人中心')
                    //     this.$router.push('/user')
                    // }
                    this.ruleFormRegister.phone = res.data.phone
                    this.ruleFormRegister.username = res.data.username
                    this.ruleFormRegister.nickname = res.data.nickname
                    this.ruleFormRegister.avatar = res.data.avatar
                    // this.ruleFormRegister.name = res.data.contactName
                    // this.ruleFormRegister.tags = res.data.businessType
                }
            }).catch(err=>{
                this.$message.error(err.message)
            })
        }
    },
    components:{
        Header
    },
    created(){
        this.getUserInformation()
    }
}
</script>

<style scoped lang="less">
@media screen and (max-width: 1500px) {
    .user_container {
        width: 100%;
    }
}
@media screen and (min-width: 1500px) {
    .user_container {
        width: 80%;
    }
}
.outer{
    background-color: #E9E9EA;
    min-height: 100vh;
}
::v-deep .el-input{
    width: auto;
}
.user{
    // background-color: #cad3d4;
    min-width: 1350px;
    padding-bottom: 5rem;
    // width: 100vw;
    // height: 100vh;
    .user_container {
        padding-top: 3.06rem;
        margin: 0 auto;
        // background-color: aquamarine;
        display: flex;
        justify-content: center;

    }
}


// .userLeft:hover{
//     color: #54d1ef;
// }
.userLeft {
    /* width: 10%; */
    /* position: fixed; */
    height: 40%;
    // margin-right: 2rem;
    color: #282828;
    height: auto;
    padding-right: 1rem;
    ul{
        padding-top: 5px;
        border-radius: 10px;
        background-color: #fff;
    }
    .item{
        padding: 1rem 0;
        // background-color: #54d1ef;
        p{
            color: #54d1ef;
            padding: 0 3rem 0 1rem;
            border-left: 4px solid #54d1ef;
        }
        a{
            color: #54d1ef;
        }
        // a:hover{
        //     color: #54d1ef;
        // }
    }
    // .item:hover{
    //     color: #54d1ef ;
    // }
}

.userRight {
    width: 70%;
    max-width: 1400px;

    border-radius: 15px;
    background-color: #ffffff;
    .right_container{
        width: 100%;
        // border-left: 1px dashed #ababab;
        .login_format{
            width: 100%;
            // background-color: chartreuse;
            padding: 2rem 2rem;
            .avatar{
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 86%;
                img{
                    width: 100px;
                    height: 100px;
                    border-radius: 90%;
                }
            }
            .phone{
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 86%;
                span{
                    display: block;
                }
            }
            .duanxin{
                .codeBtn{
                    background-color: #54d1ef;
                    border-radius: 20px;
                    padding: 8px 10px 10px 10px;
                }
                .codeBtn:hover{
                    color: #E3E8EF;
                }
                .button{
                    ::v-deep .el-button{
                        width: 100%;
                        border-radius: 20px;
                        margin-top: 1rem;
                    }
                }
            }
            .impowerBox .title{
                display: none;
            }
        }
        .title{
            font-size: 1.7rem;
            letter-spacing: 5px;
            padding: 1rem 0 2rem;
        }
        .forget{
            // background-color: #54d1ef;
            display: flex;
            justify-content: flex-end;
            span{
                cursor: pointer;
            }
            span:hover{
                color: #54d1ef;
            }
            ::v-deep .el-form-item{
                margin-bottom: 1rem !important;
            }
        }
        .other{
            text-align: center;
            color: #a3a3a3;
            font-size: 0.8rem;
            position: relative;/*定位横线（当横线的父元素）*/
            display: block;
            // padding-top: 2rem;
        }
        .other::before,
        .other::after{
            content: '';
            position: absolute;
            top: 52%;
            background: #a3a3a3;
            /*宽和高做出来的背景横线*/
            width: 100%;
            height: 1px;
        }
        .other::before {
            left: 100%;/*调整背景横线的左右距离*/
        }
        .other::after {
            right: 100%;/*调整背景横线的左右距离*/
        }
        .bottom{
            padding-top: 2rem;
            display: flex;
            .wx{
                display: flex;
                margin-right: 3rem;
                align-items: center;
                cursor: pointer;
                span{
                    margin-left: 0.5rem;
                }
            }
            .dx{
                display: flex;
                cursor: pointer;
                align-items: center;
                span{
                    margin-left: 0.5rem;
                }
            }
        }
        .button{
            // display: flex;
            // justify-content: center;
            margin-top: 1rem;
            ::v-deep .el-button{
                width: 20rem;
                border-radius: 20px;
                background-color: #54d1ef;
                color: #fff;
            }
            ::v-deep .el-form-item{
                margin-bottom: 1rem !important;
            }
        }
        ::v-deep .el-input__inner{
            // background-color: #f9b6f2;
            width: 20rem;
        }
    }
}
</style>